import styles from "./Menu.styles.scss";
import {Body} from "../typography";

const Menu = ({options, isVisible}) => {
  return isVisible ? <div className={styles.container}>
    {options.map(({label, onClick}) => <button className={styles.button} onClick={onClick}><Body size="body2">{label}</Body></button>)}
  </div> : null;
};

export default Menu;



// WEBPACK FOOTER //
// ./components/Menu/Menu.js